import React,{useRef} from "react";

///Styles
import {AiOutlineFileExcel} from 'react-icons/ai';
import { FiMoreVertical } from 'react-icons/fi';
import {Container,ButtonExcelContainer} from './styles';

///Components
import { ContainerThatCloseOutside } from "../../../ContainerThatCloseOutside";


export function ButtonExportExcel({open,setOpen,handleDownloadCSV}){
    
    const ref = useRef(null)

    function download(){
        handleDownloadCSV();
        setOpen(false)
    }
    
    return(
        <Container>
            <FiMoreVertical
                onClick={() => setOpen(!open)}
            />

            {
                open &&
                <ContainerThatCloseOutside
                    handleClickOutside={() => setOpen(false)}
                    availableToClick={open}
                    ref={ref}
                >
                    <ButtonExcelContainer>
                        <button onClick={download}>
                            <AiOutlineFileExcel />
                            Exportar Excel
                        </button>
                    </ButtonExcelContainer>
                </ContainerThatCloseOutside>
            }
        </Container>
    )
}